<template>
  <div>
    <!-- サービス情報 -->
    <div>
      <el-divider content-position="left">サービス情報</el-divider>
      <el-row :gutter="20">
        <el-col :span="12">
          <h3>日本語</h3>
          <el-form label-position="top">
            <el-form-item label="タイトル">
              <el-input
                v-model="form.service_title_ja"
                type="textarea"
                :rows="3"
                required
              />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <h3>英語</h3>
          <el-form label-position="top">
            <el-form-item label="Title">
              <el-input
                v-model="form.service_title_en"
                type="textarea"
                :rows="3"
                required
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 中古車販売情報 -->
    <div>
      <el-divider content-position="left">中古車販売情報</el-divider>
      <el-form label-position="top">
        <el-form-item label="中古車販売画像">
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="handleFileChange"
            :show-file-list="false"
            :before-upload="beforeUpload"
            list-type="picture-card"
          >
            <img v-if="imageCarUrl" :src="imageCarUrl" class="uploaded-image" />
            <el-icon v-else class="upload-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form label-position="top">
            <el-form-item label="タイトル">
              <el-input
                v-model="form.service_car_title_ja"
                type="textarea"
                :rows="2"
                required
              />
            </el-form-item>
            <el-form-item label="内容">
              <el-input
                v-model="form.service_car_content_ja"
                type="textarea"
                :rows="5"
                required
              />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form label-position="top">
            <el-form-item label="Title">
              <el-input
                v-model="form.service_car_title_en"
                type="textarea"
                :rows="2"
                required
              />
            </el-form-item>
            <el-form-item label="Content">
              <el-input
                v-model="form.service_car_content_en"
                type="textarea"
                :rows="5"
                required
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 中古パーツ販売情報 -->
    <div>
      <el-divider content-position="left">中古パーツ販売情報</el-divider>
      <el-form label-position="top">
        <el-form-item label="中古パーツ販売画像">
          <el-upload
            class="upload-demo"
            action="#"
            :http-request="handleFileChange2"
            :show-file-list="false"
            :before-upload="beforeUpload2"
            list-type="picture-card"
          >
            <img
              v-if="imagePartUrl"
              :src="imagePartUrl"
              class="uploaded-image"
            />
            <el-icon v-else class="upload-icon"><Plus /></el-icon>
          </el-upload>
        </el-form-item>
      </el-form>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form label-position="top">
            <el-form-item label="タイトル">
              <el-input
                v-model="form.service_part_title_ja"
                type="textarea"
                :rows="2"
                required
              />
            </el-form-item>
            <el-form-item label="内容">
              <el-input
                v-model="form.service_part_content_ja"
                type="textarea"
                :rows="5"
                required
              />
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form label-position="top">
            <el-form-item label="Title">
              <el-input
                v-model="form.service_part_title_en"
                type="textarea"
                :rows="2"
                required
              />
            </el-form-item>
            <el-form-item label="Content">
              <el-input
                v-model="form.service_part_content_en"
                type="textarea"
                :rows="5"
                required
              />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <!-- 保存ボタン -->
    <el-button type="primary" @click="confirmSave">保存</el-button>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { supabase } from "@/supabase.js";
import { ElMessageBox,ElMessage } from "element-plus";

export default {
  setup() {
    const form = ref({
      service_title_ja: "",
      service_title_en: "",
      service_car_title_ja: "",
      service_car_title_en: "",
      service_car_content_ja: "",
      service_car_content_en: "",
      service_part_title_ja: "",
      service_part_title_en: "",
      service_part_content_ja: "",
      service_part_content_en: "",
      service_car_img: "",
      service_part_img: "",
    });
    const imageCarUrl = ref("");
    const imagePartUrl = ref("");
    let selectedFile = null;
    let selectedFile2 = null;

    const fetchData = async () => {
      const { data, error } = await supabase
        .from("home_info")
        .select(
          "service_title_ja,service_title_en,service_car_title_ja,service_car_title_en,service_car_content_ja,service_car_content_en,service_part_title_ja,service_part_title_en,service_part_content_ja,service_part_content_en,service_car_img,service_part_img"
        )
        .eq("id", "home_info")
        .single();
      if (error) {
        console.error("データ取得エラー:", error);
        ElMessage.error("データ取得エラー");
      } else {
        form.value = data;
        imageCarUrl.value = data.service_car_img;
        imagePartUrl.value = data.service_part_img;
      }
    };

    // 📌 处理图片上传（本地预览）
    const handleFileChange = (file) => {
      selectedFile = file.file;
      const reader = new FileReader();
      reader.onload = (e) => {
        imageCarUrl.value = e.target.result;
      };
      reader.readAsDataURL(selectedFile);
    };

    // 📌 仅允许 JPG/PNG 图片
    const beforeUpload = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        ElMessage.error("JPG/PNG 形式のみ対応しています。");
        return false;
      }
      return true;
    };

    // 📌 上传图片到 Supabase Storage 并返回 URL
    const uploadImage = async () => {
      console.log("selectedFile:" + selectedFile);

      if (!selectedFile) return form.value.imageCarUrl; // 如果未选择新图片，保留原 URL

      const fileExt = selectedFile.name.split(".").pop(); // 获取文件扩展名
      const fileName = `${selectedFile.uid}.${fileExt}`; // 生成唯一文件名
      const filePath = `home_info/${fileName}`;

      // 先删除旧文件（如果有）
      if (form.value.imageCarUrl) {
        const oldFileName = form.value.imageCarUrl.split("/").pop();
        await supabase.storage.from("img").remove([`home_info/${oldFileName}`]);
      }

      // 上传新文件
      const { error } = await supabase.storage
        .from("img")
        .upload(filePath, selectedFile);

      if (error) {
        console.error("中古車画像アップロード失敗:", error);
        ElMessage.error("中古車画像アップロード失敗しました。");
        return form.value.imageCarUrl;
      }

      // 获取上传后的 URL
      return supabase.storage.from("img").getPublicUrl(filePath).data.publicUrl;
    };

    // 📌 处理图片上传（本地预览）
    const handleFileChange2 = (file) => {
      selectedFile2 = file.file;
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePartUrl.value = e.target.result;
      };
      reader.readAsDataURL(selectedFile2);
    };

    // 📌 仅允许 JPG/PNG 图片
    const beforeUpload2 = (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        ElMessage.error("JPG/PNG 形式のみ対応しています。");
        return false;
      }
      return true;
    };

    // 📌 上传图片到 Supabase Storage 并返回 URL
    const uploadImage2 = async () => {
      console.log("selectedFile:" + selectedFile2);

      if (!selectedFile2) return form.value.imagePartUrl; // 如果未选择新图片，保留原 URL

      // const filePath = `home_info/${selectedFile2.name}`;
      const fileExt = selectedFile2.name.split(".").pop(); // 获取文件扩展名
      const fileName = `${selectedFile2.uid}.${fileExt}`; // 生成唯一文件名
      const filePath = `home_info/${fileName}`;

      // 先删除旧文件（如果有）
      if (form.value.imagePartUrl) {
        const oldFileName = form.value.imagePartUrl.split("/").pop();
        await supabase.storage.from("img").remove([`home_info/${oldFileName}`]);
      }

      // 上传新文件
      const { error } = await supabase.storage
        .from("img")
        .upload(filePath, selectedFile2);

      if (error) {
        console.error("中古パーツ画像アップロード失敗:", error);
        ElMessage.error("中古パーツ画像アップロード失敗しました。");
        return form.value.imagePartUrl;
      }

      // 获取上传后的 URL
      return supabase.storage.from("img").getPublicUrl(filePath).data.publicUrl;
    };

    const saveData = async () => {
      if (
        !form.value.service_title_ja ||
        !form.value.service_title_en ||
        !form.value.service_car_title_ja ||
        !form.value.service_car_title_en ||
        !form.value.service_car_content_ja ||
        !form.value.service_car_content_en ||
        !form.value.service_part_title_ja ||
        !form.value.service_part_title_en ||
        !form.value.service_part_content_ja ||
        !form.value.service_part_content_en ||
        !imageCarUrl.value ||
        !imagePartUrl.value
      ) {
        ElMessage.error("全ての項目を入力してください。");
        return;
      }

      // 先上传图片，获取 URL
      form.value.service_car_img = await uploadImage();
      form.value.service_part_img = await uploadImage2();

      const { error } = await supabase
        .from("home_info")
        .update({
          service_title_ja: form.value.service_title_ja,
          service_title_en: form.value.service_title_en,
          service_car_title_ja: form.value.service_car_title_ja,
          service_car_title_en: form.value.service_car_title_en,
          service_car_content_ja: form.value.service_car_content_ja,
          service_car_content_en: form.value.service_car_content_en,
          service_part_title_ja: form.value.service_part_title_ja,
          service_part_title_en: form.value.service_part_title_en,
          service_part_content_ja: form.value.service_part_content_ja,
          service_part_content_en: form.value.service_part_content_en,
          service_car_img: form.value.service_car_img,
          service_part_img: form.value.service_part_img,
        })
        .eq("id", "home_info");
      if (error) {
        console.error("データ保存エラー:", error);
        ElMessage.error("保存に失敗しました。");
      } else {
        ElMessage.success("データを保存しました。");
      }
    };
    // 📌 确认保存对话框
    const confirmSave = () => {
      ElMessageBox.confirm("この内容で保存しますか？", "確認", {
        confirmButtonText: "保存",
        cancelButtonText: "キャンセル",
        type: "warning",
      })
        .then(() => {
          saveData();
        })
        .catch(() => {
          ElMessage.info("保存をキャンセルしました。");
        });
    };

    onMounted(fetchData);
    return {
      form,
      imageCarUrl,
      imagePartUrl,
      handleFileChange,
      beforeUpload,
      uploadImage,
      handleFileChange2,
      beforeUpload2,
      uploadImage2,
      confirmSave,
    };
  },
};
</script>
<style lang="stylus" scoped>
.el-divider >>> .el-divider__text {
  background-color: #f5f5f5 !important;
  color: var(--el-text-color-primary);
  font-size: 14px;
  font-weight: 500;
  padding: 0 20px;
  position: absolute;
}

.uploaded-image {
  height: 150px; /* 只控制高度 */
  width: auto; /* 宽度自适应 */
  object-fit: contain; /* 保持原比例，不裁剪 */
  border-radius: 8px; /* 圆角 */
  display: block;
  max-width: 100%; /* 防止超出父容器 */
}
:deep(.el-upload--picture-card) {
    --el-upload-picture-card-size: 148px;
    align-items: center;
    background-color: var(--el-fill-color-lighter);
    border: 1px dashed var(--el-border-color-darker);
    border-radius: 6px;
    box-sizing: border-box;
    cursor: pointer;
    display: inline-flex;
    height: var(--el-upload-picture-card-size);
    justify-content: center;
    vertical-align: top;
    width: 300px;
}
</style>
